//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'switchbox',
    inheritAttrs: true,
    props: {
        size: {
            default: 'large',
            type: String,
        },
        closeText: {
            default: "否",
            type: String,
        },
        openText: {
            default: "是",
            type: String,
        },
        value: {
            default: 0,
            type: Number
        },
    },
    data(){
        return {
            active:0,
        }
    },
    watch: {
        // 官方声明，不要使用箭头函数定义
        value: function(n,o){
            this.active = n;

            console.log(this.active);
        }
    },
    methods: {
        change(state){
            this.active = state ? 1 : 0;
            this.$emit('input',this.active);
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/ui/switchbox.vue